import Joi from 'joi';

import { PolicyStatusEnum } from '../../enums/policy-status.enum';

export const updatePolicyStatusSchema = () =>
	Joi.object({
		id: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|policy-id|cannot-be-null',
				}),
				otherwise: Joi.number().integer().positive().required().messages({
					'any.required': 'validations|policy-id|required',
					'number.base': 'validations|policy-id|must-be-number',
				}),
			})
			.required()
			.messages({
				'any.required': 'validations|policy-id|required',
			}),

		status: Joi.alternatives()
			.conditional(Joi.any().valid(null), {
				then: Joi.invalid(null).messages({
					'any.invalid': 'validations|policy-status|cannot-be-null',
				}),
				otherwise: Joi.string()
					.valid(...Object.values(PolicyStatusEnum))
					.required()
					.messages({
						'any.required': 'validations|policy-status|required',
						'any.only': 'validations|policy-status|invalid-value',
					}),
			})
			.required()
			.messages({
				'any.required': 'validations|policy-status|required',
			}),
	}).unknown();
